"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const proto_1 = __importDefault(require("@helium/proto"));
const JSLong = __importStar(require("long"));
const Transaction_1 = __importDefault(require("./Transaction"));
const utils_1 = require("./utils");
const types_1 = require("./types");
class PaymentV2 extends Transaction_1.default {
    constructor(opts) {
        super();
        this.type = 'payment_v2';
        this.payer = opts.payer;
        this.payments = opts.payments || [];
        this.nonce = opts.nonce;
        if (opts.fee !== undefined) {
            this.fee = opts.fee;
        }
        else {
            this.fee = 0;
            this.fee = this.calculateFee();
        }
        this.signature = opts.signature;
    }
    serialize() {
        const BlockchainTxn = proto_1.default.helium.blockchain_txn;
        const paymentV2 = this.toProto();
        const txn = BlockchainTxn.create({ paymentV2 });
        return BlockchainTxn.encode(txn).finish();
    }
    static fromString(serializedTxnString) {
        var _a, _b, _c, _d, _e;
        const buf = Buffer.from(serializedTxnString, 'base64');
        const decoded = proto_1.default.helium.blockchain_txn.decode(buf);
        const payer = utils_1.toAddressable((_a = decoded.paymentV2) === null || _a === void 0 ? void 0 : _a.payer);
        const payments = (((_b = decoded.paymentV2) === null || _b === void 0 ? void 0 : _b.payments) || []).map((p) => ({
            payee: utils_1.toAddressable(p.payee),
            amount: utils_1.toNumber(p.amount),
            memo: utils_1.toString(p.memo),
            tokenType: p.tokenType === undefined ? types_1.TokenType.hnt : utils_1.toNumber(p.tokenType),
        }));
        const fee = utils_1.toNumber((_c = decoded.paymentV2) === null || _c === void 0 ? void 0 : _c.fee);
        const nonce = utils_1.toNumber((_d = decoded.paymentV2) === null || _d === void 0 ? void 0 : _d.nonce);
        const signature = utils_1.toUint8Array((_e = decoded.paymentV2) === null || _e === void 0 ? void 0 : _e.signature);
        return new PaymentV2({
            payer,
            payments,
            fee,
            nonce,
            signature,
        });
    }
    async sign({ payer: payerKeypair }) {
        const PaymentTxn = proto_1.default.helium.blockchain_txn_payment_v2;
        const payment = this.toProto(true);
        const serialized = PaymentTxn.encode(payment).finish();
        this.signature = await payerKeypair.sign(serialized);
        return this;
    }
    toProto(forSigning = false) {
        const PaymentTxn = proto_1.default.helium.blockchain_txn_payment_v2;
        const Payment = proto_1.default.helium.payment;
        const payments = this.payments.map(({ payee, amount, memo, tokenType, }) => {
            const memoBuffer = memo ? Buffer.from(memo, 'base64') : undefined;
            return Payment.create({
                payee: utils_1.toUint8Array(payee.bin),
                amount,
                memo: memoBuffer ? JSLong.fromBytes(Array.from(memoBuffer), true, true) : undefined,
                tokenType: tokenType,
            });
        });
        return PaymentTxn.create({
            payer: this.payer ? utils_1.toUint8Array(this.payer.bin) : null,
            payments,
            fee: this.fee && this.fee > 0 ? this.fee : null,
            nonce: this.nonce,
            signature: this.signature && !forSigning ? utils_1.toUint8Array(this.signature) : null,
        });
    }
    calculateFee() {
        this.signature = utils_1.EMPTY_SIGNATURE;
        const payload = this.serialize();
        return Transaction_1.default.calculateFee(payload);
    }
}
exports.default = PaymentV2;
//# sourceMappingURL=PaymentV2.js.map